<template>
  <v-container fluid class="pa-0">
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" md="6" lg="4" sm="6" xs="12" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="font-weight-regular headline text-decoration-underline text-capitalize">
              Allocate Centers
              </div>
            </div>
            <v-card-actions>
              <router-link slot="right" :to="{ name: 'amsSchedulingDashboard' }">
                <v-btn
                  elevation="1"
                  absolute
                  right
                  top

                >
                  <v-icon left>mdi-arrow-left</v-icon>back</v-btn
                >
              </router-link>
            </v-card-actions>
          </v-col>
          <!-- <v-col> -->

          <!-- </v-col> -->
        </v-row>
        <v-row v-if="isSuperAdmin">
          <v-col cols="12" md="4" sm="2" xs="12">
          <v-autocomplete
            name="id"
            :items="zonalManagerList"
            v-model="zmId"
            item-value="ams_zonalManagers[0].userID"
            item-text="zmName"
            :error-messages="zoneMangerErrorMes"
          >
            <template v-slot:label> Select Zonal Manager </template>
          </v-autocomplete>
        </v-col>
          <v-col cols="12" md="2" lg="2" sm="2" xs="12">
          <div class="d-flex justify-end caption">
            <v-btn
              @click="getAllocateCenters()"
              small
              id="apply"
              color="success"
              elevation="1"
              type="submit"
              class="ml-2 mt-5"

            >
              <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
              Filter
            </v-btn>
            <v-btn
              @click="clearDataZonal()"
              small
              elevation="1"
              type="reset"

              class="ml-2 mt-5"
            >
              <v-icon left size="18"> mdi-restart</v-icon> Clear
            </v-btn>
          </div>
        </v-col>
        </v-row>
      </v-card>
      <template >
        <v-row style="margin-top: 10px;">
          <v-col cols="12" sm="6" md="4" lg="4">
          <data-card
            subIcon="mdi-calendar"
            subtitle="Till Today's Date"
            icon="mdi-account-group"
            color="accent"
            title="Total Centers"
            :value="totalCenters"
            style="cursor:pointer;"
            @click.native="centerAllocation('TC')"
          ></data-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" >
          <data-card
            subIcon="mdi-calendar"
            subtitle="Till Today's Date"
            goIcon="mdi-arrow-top-right"
            icon="mdi-account-multiple"
            color="warning"
            title="Allocated Centers"
            :value="allocatedCenters"
            style="cursor:pointer;"
            @click.native="centerAllocation('AC')"
          ></data-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" >
          <data-card
            subIcon="mdi-calendar"
            subtitle="Till Today's Date"
            goIcon="mdi-arrow-top-right"
            icon="mdi-account-alert"
            color="pink"
            title="Unallocated Centers"
            :value="unallocatedCenters"
            style="cursor:pointer;"
            @click.native="centerAllocation('UC')"
          >
          </data-card>
        </v-col>
        </v-row>
      </template>
      <template>
        <v-row>
          <v-col cols="12">
          <div class="d-flex justify-center">
            <v-subheader class="display-1 font-weight-bold has-border"
              >Allocations</v-subheader
            >
          </div>
        </v-col>
        </v-row>
      </template>
      <v-data-table
        style="margin-top: 10px;"
      :headers="headers"
      :items="allocationsList"
      >
        <template v-slot:item.actionView="{ item }">
          <v-icon color="primary" @click="viewAllocateCenters(item)">mdi-eye</v-icon>
        </template>
        <template v-slot:item.actionAllocate="{ item }">
          <span v-if="item.btnColor === 'Yellow'">
            <v-btn outlined class="px-2 ml-1 ma-1" color="warning" min-width="0" @click="allocatedCenter(item)">
              <v-icon left size="18"> mdi-text-box-check-outline </v-icon> Allocate
            </v-btn>
          </span>
          <span v-else-if="item.btnColor === 'Red'">
            <v-btn outlined class="px-2 ml-1 ma-1 non-clickable1" color="red" min-width="0">
              <v-icon left size="18"> mdi-text-box-check-outline </v-icon> Allocate
            </v-btn>
          </span>
          <span v-else-if="item.btnColor === 'Green'">
            <v-btn outlined class="px-2 ml-1 ma-1 non-clickable" color="success" min-width="0">
              <v-icon left size="18"> mdi-text-box-check-outline </v-icon> Allocate
            </v-btn>
          </span>
        </template>
      </v-data-table>
      <v-dialog
        persistent
        v-model="viewAllocate"
        max-width="1300"
        :active="viewAllocate"
        :on-cancel="
          () => {
            ;(viewAllocate = false), clearData()
          }
        ">
        <v-card>
          <v-toolbar dark color="darkblue" style="position: sticky; top: 0; z-index: 1;">
            <v-toolbar-title>Allocated Centers To : {{ academicManager.toUpperCase()  }} </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  icon
                  dark
                  @click="
                    () => {
                      ;(viewAllocate = false), clearData()
                    }
                  "
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
          </v-toolbar>
          <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
            <div>
              <v-data-table
                item-key="id"
                :headers="allocatedCentersHeaders"
                :items="allocatedCentersList"
              >
                <template v-slot:item.deleteCenter="{ item }">
                  <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small @click="deleteCenter(item, 'no')">
                    <v-icon small> mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-card>
      </v-dialog>
      <v-dialog
        persistent
        v-model="allocateCenterPopup"
        max-width="1300"
        :active="allocateCenterPopup"
        :on-cancel="
          () => {
            ;(allocateCenterPopup = false), clearData()
          }
      ">
        <v-card>
          <v-toolbar style="position: sticky; top: 0; z-index: 1;">

            <v-toolbar-title class="rcorners1"> {{ academicManager }} </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  icon
                  dark
                  @click="
                    () => {
                      ;(allocateCenterPopup = false), clearData()
                    }
                  "
                >
                  <v-icon color="black">mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
          </v-toolbar>
          <v-row style="width: 1200px;">
            <v-col cols="12" md="4" sm="2" xs="12" style="margin: 20px;">
              <v-autocomplete
                key="id"
                :items="cityList"
                v-model="cityandpincodeID"
                item-text="city"
                item-value="id"
              >
                <template v-slot:label> Select City </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" sm="2" xs="12" style="margin: 20px;">
              <v-autocomplete
                key="id"
                :items="pincodeList"
                v-model="cityandpincodeID"
                item-text="pincode"
                item-value="id"
                type="number"
                @keydown="preventDecimal"
              >
                <template v-slot:label> Select Pincode </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="1" sm="2" xs="12" style="margin-top: 20px;">
              <div class="d-flex caption">
                <v-btn

                  small
                  id="apply"
                  color="success"
                  elevation="1"
                  type="submit"
                  class="ml-2 mt-5"
                  @click="allocatedCenter(itemValue)"
                >
                  <v-icon> mdi-text-box-check-outline </v-icon>
                  Apply
                </v-btn>
              </div>
            </v-col>
            <v-col cols="12" md="1" sm="2" xs="12" style="margin-top: 20px;">
              <div class="d-flex caption">
                <v-btn
                  small
                  id="apply"
                  depressed
                  type="submit"
                  class="ml-2 mt-5"
                  @click="resetFilter(itemValue)"
                >
                <v-icon left> mdi-restart</v-icon> Reset Filter
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
            <div>
              <v-data-table
                item-key="id"
                :headers="allocateCenterHeaders"
                :items="allocateCenterList"
              >
                <template v-slot:item.radioButton="{ item }">
                  <!-- <v-container
                    class="px-0 d-flex justify-center align-center"
                    fluid
                  > -->
                  <div
                    class="px-0 d-flex justify-center align-center"
                    fluid
                  >
                    <v-radio-group v-model="centerAllocateAM">
                      <v-radio v-if="item.allocatedTo === academicManager"
                        :key="item"
                        :value="item"
                        disabled
                      ></v-radio>
                      <span v-else>
                      <v-radio
                        :key="item"
                        :value="item"
                      ></v-radio>
                    </span>
                    </v-radio-group>
                  </div>
                  <!-- </v-container> -->
                </template>
                <template v-slot:item.allocatedTo="{ item }">
                  <span v-if="item.allocatedTo === 'Unallocated'" style="color: green;">{{ item.allocatedTo }}</span>
                  <span v-else>{{ item.allocatedTo }}</span>
                </template>
              </v-data-table>
            </div>
          </v-card>
          <div style="position: sticky; bottom: 0; z-index: 1; background-color: white;">
            <v-row justify="end" style="margin:5px;">
              <v-btn outlined class="px-2 ml-1 ma-1" color="success" min-width="0" @click="saveData" type="submit" style="margin:20px;">
                Save
              </v-btn>
              <v-btn outlined class="px-2 ml-1 ma-1" color="red" min-width="0" @click="cancelData" type="submit" style="margin:20px; margin-left: 15px;">
                Cancel
              </v-btn>
            </v-row>
          </div>
        </v-card>
      </v-dialog>
  </v-container>
</template>

<script>

import DataCard from '@/components/template/DataCard'
import constants from '@/utils/constants'
import moment from 'moment'
import stores from '@/stores'
import ExportUtility from '@/utils/exportUtility'

export default {
  components: { DataCard },
  data () {
    return {
      headers: [
        {
          text: 'Zone',
          value: 'zone.name',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Academic Manager',
          value: 'user.email',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Capacity Utilization',
          value: 'capacityUtilization',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Gold',
          value: 'categoryCount.Gold',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Silver',
          value: 'categoryCount.Silver',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Bronze',
          value: 'categoryCount.Bronze',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Audit Start Date',
          value: 'firstAuditDate',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Allocated Centers',
          value: 'actionView',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Allocate Center',
          value: 'actionAllocate',
          sortable: true,
          align: 'center'
        }
      ],
      allocatedCentersHeaders: [
        {
          text: 'Center Name',
          value: 'franchisee.companyName',
          sortable: true,
          align: 'center'
        },
        {
          text: 'City',
          value: 'franchisee.city',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Pin Code',
          value: 'franchisee.pincode',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Center Category',
          value: 'franchisee.amsCenterCategory.name',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Action',
          value: 'deleteCenter',
          sortable: true,
          align: 'center'
        }
      ],
      allocateCenterHeaders: [
        {
          text: 'Select Centers',
          value: 'radioButton',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Centers Names',
          value: 'companyName',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Category',
          value: 'amsCenterCategory.name',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Allocated To',
          value: 'allocatedTo',
          sortable: true,
          align: 'center'
        }
      ],

      totalCenters: '',
      allocatedCenters: '',
      unallocatedCenters: '',
      allocationsList: [],
      viewAllocate: false,
      allocatedCentersList: [],
      academicManager: '',
      allocateCenterPopup: false,
      citys: [],
      cityID: '',
      pincodeID: '',
      allocateCenterList: [],
      isAllocatedTo: '',
      centerAllocateAM: '',
      academicManagerID: '',
      pincodeList: [],
      cityList: [],
      cityandpincodeID: '',
      itemValue: '',
      disabled: true,
      zmuserId: '',
      zonalManagerList: [],
      zmId: '',
      isSuperAdmin: false,
      filedownload: false,
      zoneMangerErrorMes: ''
    }
  },
  created: async function () {
    let userStore = stores.user
    this.isSuperAdmin = userStore.ACL.superAdmin
    if (this.isSuperAdmin) {
      await this.getZonalmanager()
    }
    if (this.isSuperAdmin === false) {
      for (const item of userStore.roles) {
        if (item.role === 'AMS_ZonalManager') {
          this.zmuserId = userStore.me.id
          this.filedownload = true
        }
      }
      await this.getAllocateCenters()
    }
  },
  methods: {
    getAllocateCenters: async function () {
      try {
        if (this.isSuperAdmin) {
          if (this.zmId === '' || this.zmId === null) {
            this.zoneMangerErrorMes = 'Please Select Zonal Manager'
            return
          }
          this.zmuserId = this.zmId
          this.zoneMangerErrorMes = ''
        }
        const response = await http.get(
          `${constants.API_URL}/api/get/allCenters?zmUserID=${this.zmuserId}`
        )

        this.totalCenters = response.data.totalCenters
        this.allocatedCenters = response.data.allocatedCenters
        this.unallocatedCenters = response.data.unAllocatedCenters

        this.allocationsList = response.data.allocation
        for (const item of this.allocationsList) {
          item.firstAuditDate = item.firstAuditDate ? moment(item.firstAuditDate).format('DD/MM/YYYY') : ''
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    viewAllocateCenters: async function (item) {
      this.viewAllocate = true
      try {
        const response = await http.get(
          `${constants.API_URL}/api/view/allocatedCenters/${item.id}`
        )
        if (response.data === 'Academic Manager data not found!') {
          this.allocatedCentersList = []
        } else {
          this.allocatedCentersList = response.data
          this.academicManager = item.academicManager
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    clearData () {
      this.allocatedCentersList = []
      this.allocateCenterList = []
      this.cityandpincodeID = ''
    },
    deleteCenter: async function (item, status) {
      try {
        if (status === 'no') {
          this.deleteAllocateCenterConfirmation(item)
          return
        }
        if (status === 'yes') {
          const response = await http.get(
            `${constants.API_URL}/api/delete/allocated-center?allocatedID=${item.id}`
          )
          if (response.status === 200) {
            this.getAllocateCenters()
            this.viewAllocate = false
            return this.$buefy.dialog.alert({
              type: 'is-info',
              message: 'Center is Deleted',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',
              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    async deleteAllocateCenterConfirmation (item) {
      this.$dialog.confirm({
        text: 'Did you want to delete',
        title: 'Confirm',
        type: 'error',
        actions: {
          false: {
            color: 'error',
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              this.deleteCenter(item, 'yes')
            }
          }
        }
      })
    },

    allocatedCenter: async function (item) {
      this.allocateCenterPopup = true
      this.itemValue = item
      this.academicManager = item.academicManager
      this.academicManagerID = item.id
      try {
        const getPincode = await http.get(
          `${constants.API_URL}/api/ams/get/city/pincodes?zoneID=${item.zone.id}`
        )
        this.pincodeList = getPincode.data
        this.cityList = getPincode.data

        let cityandpincode = ''
        if (this.cityandpincodeID) {
          cityandpincode = this.cityList.find(city => city.id === this.cityandpincodeID)
          cityandpincode = `&city=${cityandpincode.city}&pincode=${cityandpincode.pincode}`
        }

        const response = await http.get(
          `${constants.API_URL}/api/get/allocateCenterList?zoneID=${item.zone.id}${cityandpincode}`
        )
        this.allocateCenterList = response.data

        for (const item of this.allocateCenterList) {
          if (item.amsCenterAllocations.length > 0) {
            item.allocatedTo = item.amsCenterAllocations[0].ams_academicManager === null ? '' : item.amsCenterAllocations[0].ams_academicManager.user.firstName + ' ' + item.amsCenterAllocations[0].ams_academicManager.user.lastName
          } else {
            item.allocatedTo = 'Unallocated'
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    saveData: async function (confirm) {
      try {
        if (this.centerAllocateAM === '' || this.centerAllocateAM === undefined) {
          return this.$dialog.notify.info('Please Select Center', {
            position: 'top-right',
            color: 'error',
            timeout: 2000
          })
        }
        if (this.centerAllocateAM.allocatedTo !== 'Unallocated' && confirm !== 'yes') {
          this.assignAMConfirmation()
          return
        }
        if (this.centerAllocateAM.amsCenterCategory === null) {
          this.allocateCenterPopup = false
          return this.$buefy.dialog.alert({
            message: 'center category not found.',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        let utilizeCount = this.itemValue.capacityUtilization
        utilizeCount = utilizeCount.split('/')[0]

        const response = await http.post(
          `${constants.API_URL}/api/allocate/am-to-center`,
          {
            'amID': this.academicManagerID,
            'franchiseeID': this.centerAllocateAM.id,
            'categoryID': this.centerAllocateAM.amsCenterCategory.id,
            'utilizedCount': utilizeCount
          }
        )
        if (response.status === 200 && response.data === 'AM allocated successfully!') {
          this.getAllocateCenters()
          this.allocateCenterPopup = false
          this.centerAllocateAM = ''
          this.allocatedCentersList = []
          this.allocateCenterList = []
          this.cityandpincodeID = ''
          return this.$buefy.dialog.alert({
            type: 'is-success',
            message: 'Academic Manager is allocated to this franchisee',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (response.status === 200 && response.data === 'AM is already allocated to franchisee!') {
          this.getAllocateCenters()
          this.allocateCenterPopup = false
          this.centerAllocateAM = ''
          this.allocatedCentersList = []
          this.allocateCenterList = []
          this.cityandpincodeID = ''
          return this.$buefy.dialog.alert({
            type: 'is-info',
            message: 'Academic Manager is already allocated to this franchisee!',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.allocateCenterPopup = false
        this.centerAllocateAM = ''
        this.allocatedCentersList = []
        this.allocateCenterList = []
        this.cityandpincodeID = ''
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    async assignAMConfirmation (item) {
      this.$dialog.confirm({
        text: 'Are you sure, you want to transfer this center?',
        title: 'Confirm',
        type: 'error',
        actions: {
          false: {
            color: 'error',
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              this.saveData('yes')
            }
          }
        }
      })
    },
    cancelData () {
      this.allocateCenterPopup = false
      this.centerAllocateAM = ''
      this.allocatedCentersList = []
      this.allocateCenterList = []
      this.cityandpincodeID = ''
    },
    centerAllocation: async function (status) {
      console.log(this.zmId)
      if (this.isSuperAdmin === true) {
        if (this.zmId !== '') {
          this.filedownload = true
        }
      }
      if (this.filedownload === true) {
        const response = await http.get(
          `${constants.API_URL}/api/ams/get/centerdata?zmUserID=${this.zmuserId}`
        )
        if (status === 'TC') {
          const csvData = []
          response.data.Total_Centers.rows.forEach((item, index) => {
            csvData.push({
              'S.No.': index + 1,
              'Center': item.companyName,
              'Center Category': item.amsCenterCategory.name,
              'City': item.city,
              'Pincode': item.pincode,
              'Academic Manager': item.amsCenterAllocations.length === 0 ? '-' : item.amsCenterAllocations[0].ams_academicManager.user.firstName + ' ' + item.amsCenterAllocations[0].ams_academicManager.user.lastName,
              'Allocated Date & Time': moment(item.updatedAt).format('DD/MM/YYYY HH:MM')
            })
          })
          ExportUtility.convertToCsv(csvData, 'Total Centers')
        }
        if (status === 'AC') {
          const csvData = []
          response.data.allocatedCenters.forEach((item, index) => {
            csvData.push({
              'S.No.': index + 1,
              'Center': item.franchisee.companyName,
              'Center Category': item.franchisee.amsCenterCategory.name,
              'City': item.franchisee.city,
              'Pincode': item.franchisee.pincode,
              'Academic Manager': item.ams_academicManager === null ? '' : item.ams_academicManager.user.firstName + ' ' + item.ams_academicManager.user.lastName,
              'Allocated Date & Time': moment(item.updatedAt).format('DD/MM/YYYY HH:MM')
            })
          })
          ExportUtility.convertToCsv(csvData, 'Allocated Centers')
        }
        if (status === 'UC') {
          const csvData = []
          response.data.unAllocatedCenters.forEach((item, index) => {
            csvData.push({
              'S.No.': index + 1,
              'Center': item.companyName,
              'Center Category': item.amsCenterCategory ? item.amsCenterCategory.name : '-',
              'City': item.city,
              'Pincode': item.pincode
            })
          })
          ExportUtility.convertToCsv(csvData, 'Unallocated Centers')
        }
      }
    },
    resetFilter (item) {
      this.cityandpincodeID = ''
      this.centerAllocateAM = ''
      this.allocatedCenter(item)
    },
    preventDecimal (event) {
      if (event.key === '.' || event.key === ',' || event.key === 'e' || event.key === 'E' || event.key === '-' || event.key === '--') {
        event.preventDefault()
      }
    },
    getZonalmanager: async function () {
      try {
        this.isLoading = true
        const response = await http.get(
          `${constants.API_URL}/api/get-zm-listing`
        )
        this.zonalManagerList = response.data
        this.zonalManagerList = this.zonalManagerList.map((item, index) => {
          if (item.ams_zonalManagers.length > 0) {
            item.zmName = `${
              item.ams_zonalManagers.length
                ? item.ams_zonalManagers[0].user.firstName
                : '-'
            } ${
              item.ams_zonalManagers.length
                ? item.ams_zonalManagers[0].user.lastName
                : ''
            }`
            return item
          }
        })
        this.isLoading = false
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    clearDataZonal () {
      this.isLoading = true
      this.zmId = ''
      this.allocationsList = []
      this.totalCenters = ''
      this.allocatedCenters = ''
      this.unallocatedCenters = ''
      this.filedownload = false
      this.zoneMangerErrorMes = ''
      this.isLoading = false
    }
  }
}

</script>

<style scoped>
.non-clickable {
  pointer-events: none; /* Makes the button non-clickable */
}
.non-clickable1 {
  pointer-events: none; /* Makes the button non-clickable */
}
.rcorners1 {
  border-radius: 25px;
  background: yellow;
  padding: 20px;
  height: 50px;

  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;
}
</style>
